/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {AlertController, NavParams, Keyboard} from 'ionic-angular';
import {UserService} from "../../services/user.services";
import {AppDialog} from "../../component/appDialog";
import { TranslateService } from 'ng2-translate';

@Component({
  templateUrl: 'agencyUserDeposit.html',
  selector: 'agency-user-deposit-page',
})
export class AgencyUserDepositPage {
  id: string;
  dptype: string = "10";
  remark: string;
  loginName: string;
  nickName: string;
  abalance: string;
  //下级转账金额
  tamount: string;
  checkpwd: string;

  constructor(private keyboard: Keyboard,private navParams: NavParams, private alertCtrl: AlertController, private userService: UserService, private translate: TranslateService) {
    let data = navParams.get("data");
    this.loginName = data.loginname;
    this.id = data.id;
    this.nickName = data.nickname;
    this.abalance = navParams.get("abalance");
  }

  submitFn() {
    let requestData: any = {
      id: this.id,
      tamount: this.tamount,
      dptype: this.dptype,
      checkpwd: this.checkpwd,
      remark:this.remark
    };

    this.userService.agentUserDeposit(requestData, this.alertCtrl).then(data => {
      if (!data["msg"]) {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: this.translate.instant('DEPOSIT_SUCCESS')
        });
        // Update balance
        this.abalance = data["abalance"];

        this.initData();
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data["msg"]
        });
      }
    });
  }

  initData() {
    this.tamount = "";
    this.remark = "";
    this.checkpwd = "";
  }

  ionViewWillLeave(){
    this.keyboard.close();
  }
}



// WEBPACK FOOTER //
// ./src/pages/agencyUserDeposit/agencyUserDeposit.ts